import { useState, useCallback } from "react";
import { CompanyFilters } from "../models/company.model";

export interface FilterValues extends CompanyFilters {}

export function useCompanyFilters() {
  const [filters, setFilters] = useState<FilterValues>({
    page: 1,
    limit: 10,
    sortBy: "createdAt",
    sortOrder: "desc",
  });

  const updateFilters = useCallback((newFilters: Partial<FilterValues>) => {
    setFilters(prev => ({
      ...prev,
      ...newFilters,
      page: 1, // Reset to first page when filters change
    }));
  }, []);

  const updateFilter = useCallback((key: keyof FilterValues, value: any) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({
      page: 1,
      limit: 10,
      sortBy: "createdAt",
      sortOrder: "desc",
    });
  }, []);

  return {
    filters,
    updateFilters,
    updateFilter,
    clearFilters,
  };
}
